/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationDetails
 */
export interface OrganizationDetails {
    /**
     * 
     * @type {number}
     * @memberof OrganizationDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationDetails
     */
    isPublic: boolean;
}

export function OrganizationDetailsFromJSON(json: any): OrganizationDetails {
    return OrganizationDetailsFromJSONTyped(json, false);
}

export function OrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isPublic': json['is-public'],
    };
}

export function OrganizationDetailsToJSON(value?: OrganizationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is-public': value.isPublic,
    };
}


